export const SiteConsts = {
  SITE_NAME: "The Comfort Devices - Blog",
  FONT_KEY_GLOBAL_1: "Times New Roman",
  DONATE_HREF: "https://www.buymeacoffee.com/alvrineom",
};
